import { Grid, Tooltip, Typography } from "@mui/material";
import FormCheckboxField from "components/form/FormCheckboxField";
import { useFormContext } from "react-hook-form";
import { ofEvent } from "types/event";
import { TicketType } from "types/ticketType";
import { SettingsAndVisibilitySection } from "../SettingsAndVisibilitySection";

export default function PublishPage() {
  const { control, watch } = useFormContext();
  const ticketTypes: TicketType[] = watch(ofEvent("ticketTypes")) ?? [];
  const rsvpDisabled = ticketTypes.length > 0;

  return (
    <Grid container flexDirection={"column"} spacing={6}>
      <Grid item>
        <Typography variant="h6">Payment</Typography>
        <FormCheckboxField
          name={ofEvent("coinPaymentEnabled")}
          control={control}
          label={"Enable Payment"}
        />
      </Grid>
      <Grid item>
        <Typography variant="h6">Attendance</Typography>
        <Tooltip
          title={
            rsvpDisabled
              ? "Attendance is not available while ticket types are configured."
              : ""
          }
          placement="right"
        >
          <span>
            <FormCheckboxField
              name={ofEvent("rsvpEnabled")}
              control={control}
              label={"Enable attendance (members can accept/decline)"}
              disabled={rsvpDisabled}
              helperText={
                "Members with a matching membership can confirm their attendance for this event. Mutually exclusive with ticket types."
              }
            />
          </span>
        </Tooltip>
      </Grid>
      <Grid item>
        <SettingsAndVisibilitySection />
      </Grid>
    </Grid>
  );
}
